import { childMediaQuery } from '~/js/helpers';

/* globals FWP, strl_vars */
function rebuildPagination() {
	const paginationWrappers = document.querySelectorAll('.pagination');

	if (paginationWrappers) {
		paginationWrappers.forEach((pagination) => {
			const totalPages = FWP.settings.pager.total_pages;
			const currentPage = FWP.settings.pager.page;

			if (totalPages > 1) {
				const facetPageWrapper = pagination.querySelector('.facetwp-pager');
				const pages = facetPageWrapper.querySelectorAll('.facetwp-page:not(.prev):not(.next)');
				const prevPage = facetPageWrapper.querySelector('.prev');
				const nextPage = facetPageWrapper.querySelector('.next');
				const fraction = facetPageWrapper.querySelector('.page-total');
				let fractionHTML;

				if (!fraction) {
					fractionHTML = document.createElement('span');
					fractionHTML.classList.add('page-total');
					fractionHTML.innerHTML = currentPage + ' / ' + totalPages;
				} else {
					fractionHTML = fraction;
				}

				pagination.style.display = 'block';

				if (prevPage) {
					prevPage.style.display = 'block';
				}

				if (nextPage) {
					nextPage.style.display = 'block';
				}

				if (childMediaQuery('sm')) {
					pages.forEach((page) => {
						page.style.display = 'none';
					});
					if (currentPage === 1 && facetPageWrapper) {
						facetPageWrapper.insertBefore(fractionHTML, nextPage);
					} else if (!fraction && facetPageWrapper) {
						facetPageWrapper.insertBefore(fractionHTML, prevPage.nextElementSibling);
					}
				} else {
					pages.forEach((page) => {
						page.style.display = 'block';
					});
					if (fraction) {
						fraction.remove();
					}
				}
			} else {
				pagination.style.display = 'block';
			}
		});
	}
}

document.addEventListener('facetwp-loaded', () => {
	rebuildPagination();
});

window.addEventListener('resize', () => {
	rebuildPagination();
});
